module.exports = __webpack_public_path__ + "static/media/foodprint_app5_preview.e7ce94b3.jpg";